import * as React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface ICommentModalProps {
  onCommentChange?: (e: React.FormEvent) => void;
  onSave?: () => void;
  onCancel?: () => void;
  onCloseCommentModal?: () => void;
  show: boolean;
  comment: string;
  title?: string;
  description?: string;
}
const CommentModal: React.FunctionComponent<ICommentModalProps> = (props) => {
  return (
    <Modal show={props.show} onHide={props.onCloseCommentModal}>
      <Modal.Header closeButton>
        <Modal.Title>{props.title || 'Comment for your change'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Form>
            <Form.Group controlId='Comment'>
              <Form.Label>
                <strong>{props.description || 'Comment'}</strong>
              </Form.Label>
              <Form.Control
                as='textarea'
                rows={3}
                data-field='comment'
                placeholder='Enter comment'
                onChange={props.onCommentChange}
                value={props.comment}
              />
            </Form.Group>
          </Form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='danger' onClick={props.onCancel}>
          Cancel Action
        </Button>
        <Button
          variant='success'
          onClick={props.onSave}
          disabled={props.comment.length == 0}
        >
          Save Comment
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommentModal;
